<template>
  <SfAssistantChecksEmpty v-if="!hasChecks" />
  <SfAssistantChecksUnreadPanel
    v-else-if="selectedCategory === UNREAD_CHECKS"
  />
  <SfAssistantChecksAllPanel v-else-if="selectedCategory === ALL_CHECKS" />
  <SfAssistantChecksGeneralSectionPanel
    v-else-if="selectedCategory === GENERAL_CHECKS"
  />
  <SfAssistantChecksSectionPanel
    v-else
    :workflow-id="selectedCategory"
    :context-id="selectedItem"
  />
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import {
  UNREAD_CHECKS,
  ALL_CHECKS,
  GENERAL_CHECKS,
} from '@app/application/sf-assistant-checks/utils'

import { useSfAssistantChecksPage } from '../stores/page'
import SfAssistantChecksEmpty from '@app/application/sf-assistant-checks/components/sf-assistant-checks-empty.vue'
import SfAssistantChecksAllPanel from '@app/application/sf-assistant-checks/components/sf-assistant-checks-all-panel.vue'
import SfAssistantChecksUnreadPanel from '@app/application/sf-assistant-checks/components/sf-assistant-checks-unread-panel.vue'
import SfAssistantChecksSectionPanel from '@app/application/sf-assistant-checks/components/sf-assistant-checks-section-panel.vue'
import SfAssistantChecksGeneralSectionPanel from '@app/application/sf-assistant-checks/components/sf-assistant-checks-general-section-panel.vue'

interface Props {
  selectedCategory: string
  selectedItem: string
}

defineProps<Props>()

const sfAssistantChecksPageStore = useSfAssistantChecksPage()
const { hasChecks } = storeToRefs(sfAssistantChecksPageStore)
</script>
